import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import AuthActions from "./actions";
import {AuthState} from "./model";
import { store } from "application/store";
import { UserStatusEnum } from "integration/api/ApiUser/types";

const initialState: AuthState = {
  isOnLoad: true,
  isAuthenticated: false,
  cognitoData: {
    token: "",
    email: "",
    given_name: "",
    family_name: "",
    "custom:mfru_user_id": "",
  },
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuthenticated: (state, action: PayloadAction<boolean>) => {
      state.isAuthenticated = action.payload;
    },
    setOnLoad: (state, action: PayloadAction<boolean>) => {
      state.isOnLoad = true;
    },
  },
  extraReducers: (builder) => {
    // onLoad
    builder.addCase(AuthActions.onLoad.fulfilled, (state, { payload }) => {
      state.isOnLoad = false;
      state.cognitoData = payload.cognitoData;
      if (payload.userStatus === UserStatusEnum.ACTIVE) {
        state.isAuthenticated = true;
      }
    });
    builder.addCase(AuthActions.onLoad.rejected, (state, payload) => {
      state.isOnLoad = false;
    });

    // singIn
    builder.addCase(AuthActions.singIn.fulfilled, (state, action) => {
      state.cognitoData = action.payload.cognitoData;
      if (action.payload.userStatus === UserStatusEnum.ACTIVE) {
        state.isAuthenticated = true;
      }
    });

    // signOut
    builder.addCase(AuthActions.signOut.pending, () => ({
      ...initialState,
      isOnLoad: false,
    }));
  },
});

export default authSlice.reducer;
export const authSelector = () => store.getState().auth;
export const {
  setAuthenticated,
  setOnLoad
} = authSlice.actions;
